<div class="task" [class.done]="task.done != null">
  <div class="checkbox" (click)="checkboxClicked()">

  </div>
  <div class="text">
    <div class="text-2xs text-gray-600 uppercase pl-8 relative">
      <div *ngIf="getLogo() != null" [style.background-image]="'url(' + getLogo() + ')'" class="h-6 w-6 bg-gray-200 rounded-full bg-contain inline-block mr-1 absolute left-0 ml-1 vertical-center bg-no-repeat bg-center"></div>
      <div *ngIf="task.cooperation != null">
        <span class="iconify inline" data-icon="fluent:handshake-20-regular"></span>
        {{ task.cooperation.name }}
      </div>
    </div>
    <span class="text-blue-400" *ngIf="task.markedUser">
      &#64;{{ task.markedUser.displayName ? task.markedUser.displayName : task.markedUser.username }}
    </span>
    {{ task.text }}
  </div>

  <div (click)="deleteTask(task)" class="text-xs text-red-300 hover:text-red-500 cursor-pointer">Entfernen</div>
</div>
